"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8930],{

/***/ 46740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_alert_dialog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ui/alert-dialog.tsx
var alert_dialog = __webpack_require__(28238);
;// CONCATENATED MODULE: ./src/components/icons/icons8/icons8Close.tsx

const Icons8Close = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.21875 5.78125L5.78125 7.21875L14.5625 16L5.78125 24.7812L7.21875 26.2188L16 17.4375L24.7812 26.2188L26.2188 24.7812L17.4375 16L26.2188 7.21875L24.7812 5.78125L16 14.5625L7.21875 5.78125Z"
        })
    });
/* harmony default export */ var icons8Close = (Icons8Close);

// EXTERNAL MODULE: ./src/lib/utils.ts + 7 modules
var utils = __webpack_require__(15939);
;// CONCATENATED MODULE: ./src/components/custom/alert-dialog.tsx





const AppAlertDialog = (param)=>{
    let { children , title , content , toggle , open , onConfirm , className , contentClassName , type ="info" , actionText ="Continue"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialog */.aR, {
        open: open,
        onOpenChange: toggle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogTrigger */.vW, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialogContent */._T, {
                className: (0,utils.cn)("bg-[#F6F6F6]", className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialogHeader */.fY, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialogTitle */.f$, {
                                className: (0,utils.cn)("flex items-center justify-between text-sm uppercase", {
                                    "!text-red-500": type === "warning"
                                }),
                                children: [
                                    title,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogCancel */.le, {
                                        className: "border-none p-0 bg-transparent w-6.25",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons8Close, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogDescription */.yT, {
                                className: (0,utils.cn)("mt-3.75", contentClassName),
                                children: content
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogFooter */.xo, {
                        className: "mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogAction */.OL, {
                            onClick: onConfirm,
                            type: "button",
                            className: (0,utils.cn)({
                                "bg-red-500 hover:bg-red-600": type === "warning"
                            }),
                            children: actionText
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var custom_alert_dialog = (AppAlertDialog);


/***/ }),

/***/ 37015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Icons8Right_arrow = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: 26,
        height: 26,
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17.0527 7.89014L15.9541 9.01318L19.2988 12.3579H3.625V13.9204H19.2988L15.9541 17.2651L17.0527 18.3882L22.3018 13.1392L17.0527 7.89014Z"
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (Icons8Right_arrow);


/***/ }),

/***/ 88546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LogoLightFull = (props)=>//prettier-ignore
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        width: "229",
        height: "30",
        viewBox: "0 0 229 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.6377 22.5464H20.3252V17.8588H25.0347V27.2558H15.6377V22.5464Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.74412 17.8588V22.5464H9.43166V27.2558H0.034668V17.8588H4.74412Z",
                fill: "url(#paint0_linear_2617_478)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.43167 8.0459H4.74412V12.7334H0.034668V3.33645H9.43167V8.0459Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.3252 12.7334V8.04588H15.6377V3.33643H25.0347V12.7334H20.3252Z",
                fill: "url(#paint1_linear_2617_478)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                opacity: "0.5",
                d: "M221.74 15.4887C217.682 15.4887 214.479 12.3466 214.479 8.10618C214.479 3.86579 217.682 0.723633 221.74 0.723633C225.797 0.723633 229 3.86579 229 8.10618C229 12.3466 225.797 15.4887 221.74 15.4887ZM221.74 14.238C225.095 14.238 227.566 11.6754 227.566 8.10618C227.566 4.53693 225.095 1.97439 221.74 1.97439C218.384 1.97439 215.913 4.53693 215.913 8.10618C215.913 11.6754 218.384 14.238 221.74 14.238ZM220.702 12.133H218.689V4.01832H222.075C223.966 4.01832 224.973 4.8725 224.973 6.39782C224.973 7.52656 224.302 8.1977 223.265 8.44175V8.47226C225.339 8.80783 224.668 11.889 225.156 12.0415V12.133H223.082C222.685 11.767 223.356 9.26543 221.465 9.26543H220.702V12.133ZM220.702 7.64859H221.526C222.35 7.64859 223.051 7.46555 223.051 6.58086C223.051 5.69618 222.35 5.54364 221.526 5.54364H220.702V7.64859Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M44.6944 24.9883H41.8829V6.3753H45.6576L51.0202 21.0054H51.0723L56.4609 6.3753H60.2356V24.9883H57.4241V10.5404H57.3721L52.2437 24.9883H49.8748L44.7465 10.5404H44.6944V24.9883ZM64.5268 29.648C63.9541 29.648 63.5637 29.596 62.8868 29.4658V27.3832C63.3294 27.4353 63.5637 27.4613 63.9802 27.4613C64.9954 27.4613 66.1929 26.9407 66.7135 24.8581L61.3509 11.7119H64.1364L68.0151 21.8644H68.0672L71.7117 11.7119H74.393L69.1345 25.3007C67.859 28.5807 66.5834 29.648 64.5268 29.648ZM83.9232 24.9883H75.619V6.3753H83.4546C87.2814 6.3753 89.5201 8.09342 89.5201 11.0611C89.5201 13.3519 88.1665 14.4192 86.6306 14.9399V14.9919C88.583 15.3304 90.249 16.7621 90.249 19.5476C90.249 23.114 87.776 24.9883 83.9232 24.9883ZM78.4825 14.1068H83.3765C85.7194 14.1068 86.5264 13.1437 86.5264 11.4776C86.5264 9.83758 85.5372 8.84836 83.5848 8.84836H78.4825V14.1068ZM78.4825 22.5152H83.715C86.4744 22.5152 87.2553 21.1876 87.2553 19.4434C87.2553 17.491 86.0579 16.3716 84.1054 16.3716H78.4825V22.5152ZM94.4437 24.9883H91.8925V6.3753H94.4437V24.9883ZM100.457 25.3527C97.802 25.3527 96.1099 23.8168 96.1099 21.552C96.1099 18.5844 98.3487 17.6993 101.655 17.0745C103.737 16.684 105.013 16.4237 105.013 15.1221C105.013 14.1589 104.44 13.3519 102.488 13.3519C100.171 13.3519 99.4681 14.0808 99.3379 15.851H96.7347C96.8649 13.2999 98.5309 11.2954 102.592 11.2954C105.325 11.2954 107.512 12.4408 107.512 15.877V21.9686C107.512 22.9317 107.642 23.4264 108.137 23.4264C108.215 23.4264 108.293 23.4264 108.449 23.4003V24.9622C108.007 25.0664 107.564 25.1184 107.148 25.1184C105.872 25.1184 105.195 24.6238 105.039 23.114H104.987C104.128 24.4937 102.618 25.3527 100.457 25.3527ZM101.03 23.2962C103.321 23.2962 105.013 22.1247 105.013 19.8079V17.9075C104.596 18.298 103.451 18.5844 102.097 18.8707C99.7544 19.3393 98.7652 19.9901 98.7652 21.3698C98.7652 22.6194 99.442 23.2962 101.03 23.2962ZM117.072 11.3214C119.519 11.3214 121.498 12.7271 121.498 15.7729V24.9883H118.947V16.4758C118.947 14.7056 118.166 13.5081 116.239 13.5081C114.053 13.5081 112.647 14.8357 112.647 16.8402V24.9883H110.096V11.7119H112.647V13.3779H112.699C113.402 12.3627 114.781 11.3214 117.072 11.3214ZM135.58 24.9883H132.56L128.213 18.1939L126.286 20.0422V24.9883H123.735V6.3753H126.286V17.3348L132.091 11.7119H135.033L129.931 16.5799L135.58 24.9883Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M145.356 8.14386C147.513 8.17152 149.256 8.53109 150.196 8.83534C149.671 10.7715 149.173 12.597 148.703 14.8097H148.149C147.817 10.6055 146.545 9.05661 144.028 9.05661C142.507 9.05661 141.594 9.99702 141.594 11.1587C141.594 14.5884 148.896 15.3352 148.896 19.6501C148.896 22.3053 145.522 25.2925 141.262 25.2925C138.607 25.2925 136.588 24.7393 135.647 24.1585C136.201 22.0011 136.726 19.7607 137.113 17.6309H137.667C137.279 22.3053 140.571 23.8819 143.392 23.8819C145.3 23.8819 146.047 23.1351 146.047 22.0841C146.047 19.1522 138.469 18.0458 138.469 13.897C138.469 10.9098 141.484 8.14386 145.356 8.14386ZM155.035 24.5734C158.049 24.5734 159.986 17.6586 159.986 15.114C159.986 14.2289 159.681 13.897 159.183 13.897C158.077 13.897 156.058 16.7182 153.679 24.2415C154.122 24.4351 154.564 24.5734 155.035 24.5734ZM152.158 29.6074H148.037C149.613 25.3755 152.352 16.5799 152.352 14.5331C152.352 14.1736 152.213 13.9523 151.964 13.9523C151.605 13.9523 151.107 14.4225 150.388 15.4459L150.084 15.0033C151.439 12.8736 152.932 11.0204 154.537 11.0204C155.422 11.0204 156.003 11.7672 156.003 13.2885C156.003 15.0033 154.896 18.848 154.205 21.3373L154.343 21.3926C156.86 14.0629 159.377 11.0204 161.396 11.0204C162.834 11.0204 163.803 12.1821 163.803 14.1736C163.803 19.733 160.539 25.2649 155.283 25.2649C154.62 25.2649 153.984 25.1266 153.458 24.9883C153.043 26.3712 152.601 27.9202 152.158 29.6074ZM175.068 21.6692C175.068 22.0841 175.206 22.333 175.455 22.333C175.842 22.333 176.34 21.8351 177.059 20.8394L177.364 21.282C175.981 23.3841 174.487 25.2649 172.883 25.2649C171.943 25.2649 171.334 24.5734 171.334 23.1351C171.334 21.3373 172.302 17.465 172.994 14.865L172.828 14.8097C170.089 22.3607 167.987 25.2925 166.245 25.2925C164.945 25.2925 163.562 24.1032 163.562 21.7245C163.562 16.6905 168.236 10.4119 177.585 11.1864C176.534 14.5331 175.068 19.8713 175.068 21.6692ZM168.153 22.4436C169.204 22.4436 170.504 20.5352 173.574 11.9055C169.591 12.9289 167.351 17.6033 167.351 20.8671C167.351 21.9458 167.683 22.4436 168.153 22.4436ZM188.665 16.3863H188.499C187.143 13.3438 186.148 11.7396 185.18 11.7396C183.548 11.7396 181.833 15.7778 181.833 19.1245C181.833 21.2266 182.829 22.4436 184.239 22.4436C185.622 22.4436 186.839 21.6415 188.001 19.4841L188.388 19.733C187.116 22.6373 185.041 25.2649 182.248 25.2649C180.007 25.2649 177.85 23.4394 177.85 20.3415C177.85 15.7501 181.114 11.0204 186.369 11.0204C188.692 11.0204 189.605 12.2651 189.605 13.648C189.605 14.6714 189.162 15.5289 188.665 16.3863ZM197.029 11.7396C195.646 11.7396 194.235 14.2289 193.71 16.9395C196.697 15.9991 198.329 14.5055 198.329 13.3438C198.329 12.514 197.776 11.7396 197.029 11.7396ZM201.371 13.3161C201.371 15.2246 198.688 16.5522 193.654 17.2161C193.544 17.8246 193.489 18.4331 193.489 19.0416C193.489 21.5032 194.65 22.4436 196.006 22.4436C197.25 22.4436 198.688 21.5032 199.905 19.4841L200.32 19.733C199.076 22.6373 196.808 25.2649 193.931 25.2649C191.635 25.2649 189.506 23.4394 189.506 20.3415C189.506 15.6395 192.742 11.0204 198.329 11.0204C200.265 11.0204 201.371 12.0991 201.371 13.3161Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_2617_478",
                        x1: "12.5347",
                        y1: "3.33643",
                        x2: "12.5347",
                        y2: "27.2558",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#2EB39B"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#238A78"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_2617_478",
                        x1: "12.5347",
                        y1: "3.33643",
                        x2: "12.5347",
                        y2: "27.2558",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#2EB39B"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#238A78"
                            })
                        ]
                    })
                ]
            })
        ]
    });
/* harmony default export */ __webpack_exports__["Z"] = (LogoLightFull);


/***/ }),

/***/ 58930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VM": function() { return /* binding */ appLinks; },
  "ZP": function() { return /* binding */ footer; },
  "KT": function() { return /* binding */ socialLinks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/icons/icons8/icons8RightArrow.tsx
var icons8RightArrow = __webpack_require__(37015);
// EXTERNAL MODULE: ./src/components/icons/logo-light-full.tsx
var logo_light_full = __webpack_require__(88546);
// EXTERNAL MODULE: ./src/components/ui/button.tsx
var ui_button = __webpack_require__(67896);
// EXTERNAL MODULE: ./src/components/ui/input.tsx + 12 modules
var input = __webpack_require__(46156);
// EXTERNAL MODULE: ./src/hooks/useScreenSize.tsx
var useScreenSize = __webpack_require__(71346);
// EXTERNAL MODULE: ./src/components/custom/alert-dialog.tsx + 1 modules
var alert_dialog = __webpack_require__(46740);
// EXTERNAL MODULE: ./src/hooks/useListener.tsx
var useListener = __webpack_require__(96966);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(28442);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/page/home/footer/about-us.tsx





const AboutUsModal = (param)=>{
    let {} = param;
    const [show, setShow] = (0,react.useState)(false);
    (0,useListener/* useListener */.o$)(constants/* MODAL_EVENTS.ABOUT_US */.Jb.ABOUT_US, ()=>setShow(!show));
    const handleToggle = (state)=>{
        setShow(!show);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* default */.Z, {
        open: show,
        toggle: handleToggle,
        title: "About Us",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "!text-left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "Unlock the perfect space or experience with Myblankspace, the ultimate online booking platform that’s transforming how hosts and bookers connect."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "For hosts, we offer an unrivalled opportunity to showcase your retail spaces for pop-ups, stunning event centres, or extraordinary experiences, all at prices that attract eager guests and maximise your earning potential."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "For bookers, we deliver a curated selection of unique, affordable options you won’t find anywhere else, wrapped in a secure, easy to navigate platform designed to make your next big idea a reality."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary mt-1",
                    children: "Why settle for ordinary when Myblankspace empowers you to list or book with confidence, simplicity, and unbeatable value? Join us today, your perfect match\xa0is\xa0waiting!"
                })
            ]
        }),
        className: "max-w-[600px]",
        contentClassName: "max-h-[500px] overflow-auto",
        type: "info",
        actionText: "Continue"
    });
};
/* harmony default export */ var about_us = (AboutUsModal);

// EXTERNAL MODULE: ./src/components/page/home/footer/terms-and-conditions.tsx
var terms_and_conditions = __webpack_require__(39655);
;// CONCATENATED MODULE: ./src/components/page/home/footer/contact-us.tsx





const ContactUsModal = (param)=>{
    let {} = param;
    const [show, setShow] = (0,react.useState)(false);
    (0,useListener/* useListener */.o$)(constants/* MODAL_EVENTS.CONTACT_US */.Jb.CONTACT_US, ()=>setShow(!show));
    const handleToggle = (state)=>{
        setShow(!show);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* default */.Z, {
        open: show,
        toggle: handleToggle,
        title: "Contact Us",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "!text-left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "font-bold text-base sm:text-lg text-dark-primary",
                    children: "Email:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "mailto:shortlet@myblankspace.com",
                    className: "text-dark-primary",
                    children: "shortlet@myblankspace.com ↗"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "font-bold text-base sm:text-lg text-dark-primary",
                    children: "Whatsapp:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://wa.me/2349097664317",
                    className: "text-dark-primary",
                    children: "+234 909 766 4317 ↗"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "font-bold text-base sm:text-lg text-dark-primary",
                    children: "Whatsapp:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://wa.me/447860851577",
                    className: "text-dark-primary",
                    children: "+44 786 085 1577 ↗"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
            ]
        }),
        className: "max-w-[600px]",
        contentClassName: "max-h-[500px] overflow-auto",
        type: "info",
        actionText: "Continue"
    });
};
/* harmony default export */ var contact_us = (ContactUsModal);

;// CONCATENATED MODULE: ./src/components/page/home/footer/pirivacy-policy.tsx





const PrivacyPolicyModal = (param)=>{
    let {} = param;
    const [show, setShow] = (0,react.useState)(false);
    (0,useListener/* useListener */.o$)(constants/* MODAL_EVENTS.PRIVACY_POLICY */.Jb.PRIVACY_POLICY, ()=>setShow(!show));
    const handleToggle = (state)=>{
        setShow(!show);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* default */.Z, {
        open: show,
        toggle: handleToggle,
        title: "Privacy Policy",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "!text-left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "Our privacy policy of outlines how we manage and protect the personal information of users."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "Myblankspace collects personal data such as names, email addresses, phone numbers, and payment information to facilitate transactions, manage bookings, and improve their services. This data is essential for processing payments and establishing agreements between brands (renters) and landlords."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "In terms of usage, personal data is also leveraged to enhance the user experience on their platform, as well as for marketing purposes. Users might receive newsletters or promotional content, but they have the option to opt out of these communications at any time. Additionally, we use anonymised data for analytical purposes, helping us refine our services."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "While we do not sell personal data, we may share it with trusted third parties, such as service providers or landlords, to fulfil contracts or prevent fraud. Myblankspace"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-dark-primary",
                    children: "Security is a priority of ours, as a result we use encryption and other protective measures to safeguard personal data from unauthorised access. Users also have rights over their data, including the ability to request access, make corrections, or delete their information. Furthermore, users can withdraw consent for marketing communications at any time."
                })
            ]
        }),
        className: "max-w-[600px]",
        contentClassName: "max-h-[500px] overflow-auto",
        type: "info",
        actionText: "Continue"
    });
};
/* harmony default export */ var pirivacy_policy = (PrivacyPolicyModal);

// EXTERNAL MODULE: ./src/hooks/useRequest.ts + 1 modules
var useRequest = __webpack_require__(93551);
// EXTERNAL MODULE: ./src/apis/users.apis.ts
var users_apis = __webpack_require__(61326);
// EXTERNAL MODULE: ./src/components/ui/use-toast.ts
var use_toast = __webpack_require__(76718);
// EXTERNAL MODULE: ./node_modules/next/navigation.js
var navigation = __webpack_require__(39332);
;// CONCATENATED MODULE: ./src/components/page/home/footer/index.tsx

















const Footer = ()=>{
    const ref = (0,react.useRef)(null);
    const { width  } = (0,useScreenSize/* default */.Z)();
    const { toast  } = (0,use_toast/* useToast */.pm)();
    const subReq = (0,useRequest/* useRequest */.QT)(users_apis/* SubscribeToNewsletter */.Cm);
    const router = (0,navigation.useRouter)();
    const subscribe = async ()=>{
        var ref1;
        const value = (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.value; // email
        if (value && value !== "" && value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            const [res, err] = await subReq.makeRequest({
                email: value
            });
            if (res) {
                toast({
                    variant: "default",
                    description: "You've subscribed successfully"
                });
            }
            if (err) {
                toast({
                    variant: "destructive",
                    description: err.message
                });
            }
        } else {
            toast({
                variant: "destructive",
                description: "Please enter a valid email"
            });
        }
    };
    const isSmall = width < 1024;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "w-full relative pt-25 min-h-[1000px] overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://storage.googleapis.com/myblankspace-prod/assets/footer-bg.png",
                className: "w-full h-full object-cover absolute left-0 right-0 top-0",
                alt: ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-[-400px] right-[-30%]",
                children: illustration
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-5 lg:px-25",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-white tracking-tight text-3xl md:text-4xl lg:text-5xl max-w-[500px]",
                                children: [
                                    "Create your account today & start booking",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-display",
                                        children: "Spaces"
                                    }),
                                    " today"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                onClick: ()=>router.push("/auth/signup"),
                                variant: "secondary",
                                className: "rounded-full bg-white h-10 mt-5 lg:mt-[50px]",
                                children: "SIGN UP ↗"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-[150px] pt-25 pb-17.5 bg-black bg-opacity-20 px-5 md:px-25 backdrop-blur-lg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col md:flex-row justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex gap-10 text-sm sm:text-base lg:text-xl tracking-tight",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "space-y-2.5",
                                                children: appLinks.map((l, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "hover:text-opacity-100 text-opacity-70 text-white ",
                                                            onClick: l.onClick,
                                                            children: l.label
                                                        })
                                                    }, i))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "space-y-2.5",
                                                children: socialLinks.map((l, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "hover:text-opacity-100 text-opacity-70 text-white ",
                                                            href: l.href,
                                                            target: "_blank",
                                                            children: l.label
                                                        })
                                                    }, i + "s"))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-fit md:mt-0 mt-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.II, {
                                                ref: ref,
                                                inputSize: isSmall ? "md" : "lg",
                                                prefixIcon: input/* ICONS.EMAIL */.UZ.EMAIL,
                                                className: "w-[250px] lg:w-[350px] text-white h-fit placeholder:text-[rgba(255,255,255,0.6)]",
                                                placeholder: "Enter your Email",
                                                iconsClassName: "fill-white"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex items-center mt-5 justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-white md:text-xl",
                                                        children: [
                                                            "Join our ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-display",
                                                                children: "Newsletter"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                                        onClick: subscribe,
                                                        className: "w-7.5 h-7.5 md:w-10 md:h-10 bg-white rounded-full p-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons8RightArrow/* default */.Z, {
                                                            className: "fill-dark-primary "
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-25 lg:mt-[150px] flex md:flex-row flex-col md:justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://storage.googleapis.com/myblankspace-prod/assets/quality-disclaimer.png",
                                        className: "w-25 lg:w-[150px] border border-white border-opacity-10",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col md:items-end gap-2.5 mt-5 md:mt-0 lg:gap-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_light_full/* default */.Z, {
                                                className: "lg:w-auto w-[150px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: " text-[10px] sm:text-xs md:text-1xs text-white text-opacity-30",
                                                children: "\xa9 2024 MYBLANKSPACE. ALL RIGHTS RESERVED"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(about_us, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_and_conditions/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_us, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pirivacy_policy, {})
        ]
    });
};
/* harmony default export */ var footer = (Footer);
const illustration = //prettier-ignore
/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    width: "1220",
    height: "1200",
    viewBox: "0 0 1220 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M790.224 0.112061L948.568 274.373L881.468 458.73L723.123 184.469L790.224 0.112061Z",
            fill: "url(#paint0_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M515.963 158.457L790.224 0.112061L723.123 184.469L448.862 342.813L515.963 158.457Z",
            fill: "url(#paint1_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M948.568 274.372L811.118 353.729L744.018 538.085L881.468 458.729L948.568 274.372Z",
            fill: "url(#paint2_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M811.119 353.729L732.131 216.918L665.031 401.275L744.019 538.086L811.119 353.729Z",
            fill: "url(#paint3_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M732.131 216.918L595.321 295.906L528.22 480.263L665.031 401.275L732.131 216.918Z",
            fill: "url(#paint4_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M595.321 295.906L515.964 158.456L448.863 342.813L528.22 480.263L595.321 295.906Z",
            fill: "url(#paint5_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M860.551 439.35L998.001 359.993L930.901 544.35L793.451 623.707L860.551 439.35Z",
            fill: "url(#paint6_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M998.001 359.993L1156.35 634.254L1089.25 818.611L930.901 544.35L998.001 359.993Z",
            fill: "url(#paint7_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M405.201 222.406L484.558 359.856L417.457 544.212L338.1 406.762L405.201 222.406Z",
            fill: "url(#paint8_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M939.54 576.161L860.552 439.35L793.451 623.707L872.439 760.517L939.54 576.161Z",
            fill: "url(#paint9_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M130.94 380.75L405.201 222.406L338.1 406.762L63.8395 565.107L130.94 380.75Z",
            fill: "url(#paint10_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M484.557 359.855L347.746 438.843L280.646 623.2L417.457 544.212L484.557 359.855Z",
            fill: "url(#paint11_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M802.728 655.147L939.539 576.159L872.439 760.516L735.628 839.504L802.728 655.147Z",
            fill: "url(#paint12_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1156.35 634.253L882.084 792.598L814.984 976.954L1089.24 818.61L1156.35 634.253Z",
            fill: "url(#paint13_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M347.747 438.843L426.735 575.654L359.635 760.01L280.647 623.2L347.747 438.843Z",
            fill: "url(#paint14_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M882.085 792.598L802.728 655.147L735.628 839.504L814.985 976.954L882.085 792.598Z",
            fill: "url(#paint15_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M289.285 655.01L130.94 380.75L63.8401 565.106L222.185 839.367L289.285 655.01Z",
            fill: "url(#paint16_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M426.735 575.655L289.285 655.011L222.184 839.368L359.634 760.011L426.735 575.655Z",
            fill: "url(#paint17_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M691.966 719.099L771.323 856.549L704.223 1040.91L624.866 903.455L691.966 719.099Z",
            fill: "url(#paint18_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M555.156 798.086L691.966 719.099L624.866 903.455L488.055 982.443L555.156 798.086Z",
            fill: "url(#paint19_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M476.168 661.274L555.156 798.085L488.055 982.442L409.068 845.631L476.168 661.274Z",
            fill: "url(#paint20_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M338.718 740.631L476.168 661.274L409.068 845.631L271.618 924.988L338.718 740.631Z",
            fill: "url(#paint21_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M771.323 856.548L497.062 1014.89L429.962 1199.25L704.222 1040.9L771.323 856.548Z",
            fill: "url(#paint22_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M497.062 1014.89L338.718 740.631L271.617 924.988L429.962 1199.25L497.062 1014.89Z",
            fill: "url(#paint23_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M802.728 655.149L939.539 576.161L860.551 439.35L998.001 359.993L1156.35 634.254L882.085 792.599L802.728 655.149Z",
            fill: "url(#paint24_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M476.167 661.275L555.155 798.086L691.966 719.098L771.323 856.548L497.062 1014.89L338.717 740.632L476.167 661.275Z",
            fill: "url(#paint25_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M484.558 359.856L347.747 438.844L426.735 575.655L289.285 655.012L130.94 380.751L405.201 222.406L484.558 359.856Z",
            fill: "url(#paint26_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M811.118 353.73L732.13 216.919L595.32 295.907L515.963 158.457L790.224 0.112061L948.568 274.373L811.118 353.73Z",
            fill: "url(#paint27_linear_2953_20)"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2953_20",
                    x1: "725.147",
                    y1: "37.6843",
                    x2: "946.545",
                    y2: "421.157",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint1_linear_2953_20",
                    x1: "588.016",
                    y1: "116.857",
                    x2: "651.07",
                    y2: "226.069",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint2_linear_2953_20",
                    x1: "814.766",
                    y1: "351.622",
                    x2: "877.82",
                    y2: "460.835",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint3_linear_2953_20",
                    x1: "667.054",
                    y1: "254.491",
                    x2: "809.096",
                    y2: "500.514",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint4_linear_2953_20",
                    x1: "598.649",
                    y1: "293.985",
                    x2: "661.703",
                    y2: "403.197",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint5_linear_2953_20",
                    x1: "450.887",
                    y1: "196.029",
                    x2: "593.297",
                    y2: "442.691",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint6_linear_2953_20",
                    x1: "864.199",
                    y1: "437.244",
                    x2: "927.253",
                    y2: "546.456",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint7_linear_2953_20",
                    x1: "932.924",
                    y1: "397.565",
                    x2: "1154.32",
                    y2: "781.039",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint8_linear_2953_20",
                    x1: "340.124",
                    y1: "259.978",
                    x2: "482.534",
                    y2: "506.64",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint9_linear_2953_20",
                    x1: "795.475",
                    y1: "476.922",
                    x2: "937.516",
                    y2: "722.945",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint10_linear_2953_20",
                    x1: "202.993",
                    y1: "339.15",
                    x2: "266.047",
                    y2: "448.362",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint11_linear_2953_20",
                    x1: "351.075",
                    y1: "436.922",
                    x2: "414.128",
                    y2: "546.134",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint12_linear_2953_20",
                    x1: "806.057",
                    y1: "653.226",
                    x2: "869.11",
                    y2: "762.438",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint13_linear_2953_20",
                    x1: "954.138",
                    y1: "750.997",
                    x2: "1017.19",
                    y2: "860.21",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint14_linear_2953_20",
                    x1: "282.67",
                    y1: "476.415",
                    x2: "424.712",
                    y2: "722.438",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint15_linear_2953_20",
                    x1: "737.651",
                    y1: "692.72",
                    x2: "880.062",
                    y2: "939.382",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint16_linear_2953_20",
                    x1: "65.8634",
                    y1: "418.322",
                    x2: "287.262",
                    y2: "801.795",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint17_linear_2953_20",
                    x1: "292.933",
                    y1: "652.905",
                    x2: "355.986",
                    y2: "762.117",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint18_linear_2953_20",
                    x1: "626.889",
                    y1: "756.671",
                    x2: "769.3",
                    y2: "1003.33",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint19_linear_2953_20",
                    x1: "558.484",
                    y1: "796.165",
                    x2: "621.538",
                    y2: "905.377",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint20_linear_2953_20",
                    x1: "411.091",
                    y1: "698.846",
                    x2: "553.132",
                    y2: "944.869",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint21_linear_2953_20",
                    x1: "342.366",
                    y1: "738.525",
                    x2: "405.42",
                    y2: "847.737",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint22_linear_2953_20",
                    x1: "569.115",
                    y1: "973.293",
                    x2: "632.169",
                    y2: "1082.5",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint23_linear_2953_20",
                    x1: "273.641",
                    y1: "778.203",
                    x2: "495.039",
                    y2: "1161.68",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#2EB39B"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.68",
                            stopColor: "#08211C",
                            "stop-opacity": "0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint24_linear_2953_20",
                    x1: "826.704",
                    y1: "824.574",
                    x2: "460.582",
                    y2: "190.431",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#269682"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#185E51"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint25_linear_2953_20",
                    x1: "826.704",
                    y1: "824.574",
                    x2: "460.582",
                    y2: "190.431",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#269682"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#185E51"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint26_linear_2953_20",
                    x1: "826.704",
                    y1: "824.574",
                    x2: "460.582",
                    y2: "190.431",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#269682"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#185E51"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint27_linear_2953_20",
                    x1: "826.704",
                    y1: "824.574",
                    x2: "460.582",
                    y2: "190.431",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#269682"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#185E51"
                        })
                    ]
                })
            ]
        })
    ]
});
const appLinks = [
    {
        label: "About Us ",
        isExternal: false,
        href: "",
        onClick: ()=>(0,useListener/* emit */.j8)(constants/* MODAL_EVENTS.ABOUT_US */.Jb.ABOUT_US)
    },
    {
        label: "Privacy Policy",
        isExternal: false,
        href: "",
        onClick: ()=>(0,useListener/* emit */.j8)(constants/* MODAL_EVENTS.PRIVACY_POLICY */.Jb.PRIVACY_POLICY)
    },
    {
        label: "Terms of Service",
        isExternal: false,
        href: "",
        onClick: ()=>(0,useListener/* emit */.j8)(constants/* MODAL_EVENTS.TERMS_AND_CONDITIONS */.Jb.TERMS_AND_CONDITIONS)
    },
    {
        label: "Contact Us",
        isExternal: false,
        href: "",
        onClick: ()=>(0,useListener/* emit */.j8)(constants/* MODAL_EVENTS.CONTACT_US */.Jb.CONTACT_US)
    }
];
const socialLinks = [
    {
        label: "Instagram",
        isExternal: true,
        href: "https://www.instagram.com/myblankspacehq"
    },
    {
        label: "TikTok",
        isExternal: true,
        href: "https://www.tiktok.com/@myblankspacehq"
    },
    {
        label: "Twitter / X",
        isExternal: true,
        href: "https://twitter.com/myblankspacehq"
    },
    {
        label: "Facebook",
        isExternal: true,
        href: "https://www.facebook.com/myblankspacehq"
    }
];


/***/ }),

/***/ 39655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_custom_alert_dialog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46740);
/* harmony import */ var _src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96966);
/* harmony import */ var _src_lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28442);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





const TermsAndConditionsModal = (param)=>{
    let {} = param;
    const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    (0,_src_hooks_useListener__WEBPACK_IMPORTED_MODULE_2__/* .useListener */ .o$)(_src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .MODAL_EVENTS.TERMS_AND_CONDITIONS */ .Jb.TERMS_AND_CONDITIONS, ()=>setShow(!show));
    const handleToggle = (state)=>{
        setShow(!show);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_custom_alert_dialog__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        open: show,
        toggle: handleToggle,
        title: "Terms & Conditions",
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "!text-left",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: " text-dark-primary",
                    children: 'Terms and Conditions for Partners (Refered to as "Hosts/Landlords")'
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "font-bold text-lg text-dark-primary",
                    children: "Introduction"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-dark-primary",
                    children: 'MyBlankSpace Limited ("MyBlankSpace") is a limited liability company incorporated under the laws of Nigeria. Myblankspace is the commercial short-let platform that allows Individuals, Businesses and NGOs the flexibility to rent a on a short term contract at a reasonable price.'
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "font-bold text-lg text-dark-primary",
                    children: "Services Agreement"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-dark-primary",
                    children: 'This Services Agreement ("SA" or "this Agreement") is a legal and binding agreement between MyBlankSpace and you, ("you", "the Landlord") who has set up a MyBlankSpace account to access the Services offered by MyBlankSpace. It provides a general description of the Services that MyBlankSpace may provide to our Landlords and what is expected of our Landlords.'
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-dark-primary",
                    children: [
                        "1. Listing Creation: - Hosts must provide accurate and complete information about their listing, including its location, amenities, pricing, availability, and any commercial space rules. - Hosts are responsible for keeping their listing information up-to-date.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "2. Compliance with Laws: - Hosts must comply with all applicable laws, including zoning regulations, rental laws, and health and safety standards. - Hosts are responsible for obtaining any necessary permits or licenses.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "3.Exclusivity of Listings. - Host agree that any property listed on MyBlankSpace shall not be listed on any other short- term rental market platform or similar service for the duration of its listing on MyBlankSpace. Partners acknowledge and agree that this exclusivity requirement is a material term of this agreement, and any violation of this clause may result in immediate termination of the listing and potential suspension or termination of the Host’s account.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "4. Booking and Cancellations: - MyBlankSpace facilitates bookings and payments between clients and hosts. - Hosts set their own cancellation policies, which must be clearly communicated to clients (renter).",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "5. Fees and Payouts: - MyBlankSpace charges 10% booking fee for each booking, which is deducted from the payout to the host. - Payouts to hosts are made at month end and typically occur after the client booking has been fulfilled by host.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "6. Host Responsibilities: - Hosts are expected to maintain their property in a clean and safe condition. - Hosts must address any issues or complaints from clients promptly and professionally.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "7. Unsuccessful Listing Applications: - MyBlankSpace reserves right to reject listing application that fails to meet quality control standards. - Listings are expected to fit for purpose and safe for client use.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "7. Insurance and Liability: - Hosts should have their own insurance coverage to protect against property damage or liability claims.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "8. Prohibited Activities: - Hosts must not engage in any activities that violate MyBlankSpace's policies, such as discrimination, fraud, or creating fake listings. - Listings must not contain any content that is offensive, harmful, or illegal.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "9. Termination: - MyBlankSpace reserves the right to terminate a host’s account or remove listings that violate its terms and policies. - Hosts can also deactivate their listing or terminate their account after a weeks notice to Myblankspace via email addressed to shortlet@myblankspace.com.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "10. Dispute Resolution: - MyBlankSpace provides a process for resolving disputes between clients and hosts, which may involve mediation or arbitration.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "11. Force Majeure - Neither party will be liable for any delays in processing or other non-performance caused by telecommunications, utility failures, or equipment failures; industrial labour strike, riots, war, or terrorist attacks; non performance of our vendors or supplier, epidemic, pandemic, fires or acts of nature; action of government entities or any other event over which the respective party has no reasonable control. - However, nothing in this section will affect or excuse your liabilities or your obligation to pay Fees, Fines, Disputes, refunds, Reversals, or Returns under this Agreement.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "12. Right to Amend - We have the right to change or add to the terms of this Agreement at any time and to change, delete, discontinue, or impose conditions on use of the Services by posting such changes on our website. We will provide you with Notice of any changes through the Dashboard, via email, or through other reasonable means. If you are an existing MyBlankSpace user, the changes will come into effect on the date we specify in the Notice, and your use of the Services, API, or Data after a change has taken effect, constitutes your acceptance of the terms of the modified Agreement. You can access a copy of the current terms of this Agreement on our website or your Dashboard at any time.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "13. Termination -",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "13.1 This Agreement is effective upon the date you first access or use the Services and continues until terminated by you or MyBlankSpace. You may terminate this Agreement by closing your MyBlankSpace Account after one week notice and ceasing to use the Service. If you use the Services again or register for another MyBlankSpace Account, you are consenting to this Agreement. - We may terminate this Agreement or close your MyBlankSpace Account at any time for any reason (including, without limitation, for any activity that may create harm or loss to the goodwill of clients) by providing you advance Notice (which shall not be less than 24 hours). We may suspend your MyBlankSpace Account and your ability to access the Services, or terminate this Agreement, on immediate Notice if: - a. we determine in our sole discretion that you are ineligible for the Services because of significant fraud or any other risks associated with your MyBlankSpace Account; - b. you use the Services in a prohibited manner or otherwise do not comply with any of the - c. we receive a regulatory directive to do so;",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "13.2 Effect of Termination: - a. Termination of this Agreement or your MyBlankSpace Account does not immediately relieve you of obligations incurred by you under this Agreement. Upon termination, you agree to (i) complete all pending Transactions, (ii) stop accepting new Transactions, and (iii) immediately remove all MyBlankSpace logos from your commercial property. - Your continued or renewed use of the Services after all pending Transactions have been processed serves to renew your consent to the terms of this Agreement. If you terminate this Agreement, we will liaise with our Acquirers to pay out any remaining funds owed to you in accordance with the provisions of this Agreement.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "14. Employing MyBlankSpace Employees - You shall not offer any employment to any employee of MyBlankSpace for a period of six (6) months, after the employee has left the employ of MyBlankSpace, without the prior written consent of MyBlankSpace.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "15. Anti Bribery Provisions and Sanctions - You represent and undertake to MyBlankSpace that: - a. you will comply with Anti-Corruptions Laws; - b. you shall not undertake any act or engage (directly or in agreement with others or any third party) in any activities directly or indirectly with respect to any matters, either in private or public dealings which would violate any Anti-Corruption Laws or be considered as being unethical, fraudulent, illegal or improper;",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "16.Language - The parties hereby acknowledge that they have required this Agreement and all related documents to be in the English language."
                    ]
                })
            ]
        }),
        className: "max-w-[600px]",
        contentClassName: "max-h-[500px] overflow-auto",
        type: "info",
        actionText: "Continue"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TermsAndConditionsModal);


/***/ }),

/***/ 28238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OL": function() { return /* binding */ AlertDialogAction; },
/* harmony export */   "_T": function() { return /* binding */ AlertDialogContent; },
/* harmony export */   "aR": function() { return /* binding */ AlertDialog; },
/* harmony export */   "f$": function() { return /* binding */ AlertDialogTitle; },
/* harmony export */   "fY": function() { return /* binding */ AlertDialogHeader; },
/* harmony export */   "le": function() { return /* binding */ AlertDialogCancel; },
/* harmony export */   "vW": function() { return /* binding */ AlertDialogTrigger; },
/* harmony export */   "xo": function() { return /* binding */ AlertDialogFooter; },
/* harmony export */   "yT": function() { return /* binding */ AlertDialogDescription; }
/* harmony export */ });
/* unused harmony exports AlertDialogPortal, AlertDialogOverlay */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38074);
/* harmony import */ var _src_lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15939);
/* harmony import */ var _src_components_ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67896);





const AlertDialog = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Root */ .fC;
const AlertDialogTrigger = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Trigger */ .xz;
const AlertDialogPortal = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Portal */ .h_;
const AlertDialogOverlay = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Overlay */ .aV, {
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    });
});
AlertDialogOverlay.displayName = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Overlay.displayName */ .aV.displayName;
const AlertDialogContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AlertDialogPortal, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AlertDialogOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Content */ .VY, {
                ref: ref,
                className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-gray-200 bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg dark:border-gray-800 dark:bg-gray-950", className),
                ...props
            })
        ]
    });
});
AlertDialogContent.displayName = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Content.displayName */ .VY.displayName;
const AlertDialogHeader = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
};
AlertDialogHeader.displayName = "AlertDialogHeader";
const AlertDialogFooter = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
};
AlertDialogFooter.displayName = "AlertDialogFooter";
const AlertDialogTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("text-lg font-semibold", className),
        ...props
    });
});
AlertDialogTitle.displayName = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Title.displayName */ .Dx.displayName;
const AlertDialogDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Description */ .dk, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)("text-sm text-gray-500 dark:text-gray-400", className),
        ...props
    });
});
AlertDialogDescription.displayName = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Description.displayName */ .dk.displayName;
const AlertDialogAction = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Action */ .aU, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)((0,_src_components_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .buttonVariants */ .d)(), className),
        ...props
    });
});
AlertDialogAction.displayName = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Action.displayName */ .aU.displayName;
const AlertDialogCancel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Cancel */ .$j, {
        ref: ref,
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_2__.cn)((0,_src_components_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .buttonVariants */ .d)({
            variant: "outline"
        }), "mt-2 sm:mt-0", className),
        ...props
    });
});
AlertDialogCancel.displayName = _radix_ui_react_alert_dialog__WEBPACK_IMPORTED_MODULE_4__/* .Cancel.displayName */ .$j.displayName;



/***/ }),

/***/ 71346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export BreakPoint */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var BreakPoint;
(function(BreakPoint) {
    BreakPoint[BreakPoint["xs"] = 0] = "xs";
    BreakPoint[BreakPoint["sm"] = 1] = "sm";
    BreakPoint[BreakPoint["m"] = 2] = "m";
    BreakPoint[BreakPoint["l"] = 3] = "l";
    BreakPoint[BreakPoint["xl"] = 4] = "xl";
})(BreakPoint || (BreakPoint = {}));
const useScreenSize = ()=>{
    const getSize = function() {
        const width = window === null || window === void 0 ? void 0 : window.innerWidth;
        return {
            width: width,
            height: window === null || window === void 0 ? void 0 : window.innerHeight,
            screen: BreakPoint.sm,
            isSmall: width < 520
        };
    };
    var [screenSize, setScreenSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 300,
        height: 300,
        screen: BreakPoint.sm,
        isSmall: true
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setScreenSize(getSize());
        function handleResize() {
            setScreenSize(getSize());
        }
        window.addEventListener("resize", handleResize);
        return ()=>{
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    if (screenSize.width < 520) {
        screenSize.screen = BreakPoint.xs;
    } else if (screenSize.width >= 520 && screenSize.width < 800) {
        screenSize.screen = BreakPoint.sm;
    } else if (screenSize.width >= 800 && screenSize.width < 1024) {
        screenSize.screen = BreakPoint.m;
    } else if (screenSize.width >= 1024 && screenSize.width < 1280) {
        screenSize.screen = BreakPoint.l;
    } else {
        screenSize.screen = BreakPoint.xl;
    }
    return screenSize;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScreenSize);


/***/ })

}]);